import { css } from 'styled-components';

export default function () {
    return css`
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    `;
}
